import { render, staticRenderFns } from "./Viq.vue?vue&type=template&id=63f4babe&scoped=true"
import script from "./Viq.vue?vue&type=script&lang=js"
export * from "./Viq.vue?vue&type=script&lang=js"
import style0 from "./Viq.vue?vue&type=style&index=0&id=63f4babe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f4babe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63f4babe')) {
      api.createRecord('63f4babe', component.options)
    } else {
      api.reload('63f4babe', component.options)
    }
    module.hot.accept("./Viq.vue?vue&type=template&id=63f4babe&scoped=true", function () {
      api.rerender('63f4babe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Viq.vue"
export default component.exports